import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, computed, useStore } from "@nuxtjs/composition-api";

import { useI18n } from "@/composables";
import { useCreatorProductStore } from "@/store/creator-products";
import { getExperimentsStore } from "@/store/experiments";
import { getProductDetailsStore } from "@/store/product-details";
import { getProductsStore } from "@/store/products";
import { FEATURE_FLAG_ACTIVE, FLAG_CREATOR_SHOP_SEARCH } from "@/utils/experiments/constants";
import { Actions } from "@/utils/snowplow/enums";
import { createProductImpression } from "@/utils/snowplow/factory";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFeedItem',
  props: {
  productId: { type: String, required: true },
  profileId: { type: String, required: true },
  position: { type: Number, required: false, default: null },
  height: { type: [String, Number], required: true },
  width: { type: [String, Number], required: true },
  isSearch: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const i18n = useI18n();
const store = useStore();
const creatorProductStore = useCreatorProductStore();
const experimentsStore = getExperimentsStore(store);
const productsStore = getProductsStore(store);
const productDetailsStore = getProductDetailsStore(store);

const isCreatorShopSearchEnabled = computed(
  () => experimentsStore.flag(FLAG_CREATOR_SHOP_SEARCH)?.value === FEATURE_FLAG_ACTIVE,
);

const product = creatorProductStore.getProductById(props.productId);
const searchProduct = computed(() => productsStore.products[props.productId]);
const isConsumerSearch = computed(() => isCreatorShopSearchEnabled.value && props.isSearch);

const productDetails = computed(() => productDetailsStore.productDetails[searchProduct.value?.productDetailsId ?? ""]);
const productImage = computed(() => {
  const isConsumerSearchValue = isConsumerSearch.value;
  const searchProductValue = searchProduct.value;
  if (isConsumerSearchValue) {
    return searchProductValue?.imageUrl;
  }
  return product?.mediaObject?.mediaCdnUrl;
});
const productName = computed(() => {
  const isConsumerSearchValue = isConsumerSearch.value;
  if (isConsumerSearchValue) {
    return productDetails.value?.name;
  }
  return product?.productDetail?.name;
});
const productUrl = computed(() => {
  const isConsumerSearchValue = isConsumerSearch.value;
  const searchProductValue = searchProduct.value;
  if (isConsumerSearchValue) {
    return searchProductValue?.hyperlink;
  }
  return product?.linkUrl;
});
const productPrice = computed(() => {
  const isConsumerSearchValue = isConsumerSearch.value;
  if (isConsumerSearchValue) {
    return Intl.NumberFormat(i18n.locale, {
      style: "currency",
      currency: productDetails.value?.currency ?? "USD",
    }).format(productDetails.value?.price ?? 0);
  }
  return Intl.NumberFormat(i18n.locale, { style: "currency", currency: "USD" }).format(
    product?.productDetail?.price ?? 0,
  );
});

const amplitudePayload: ComputedRef<LtkProductProps> = computed(() => {
  const isConsumerSearchValue = isConsumerSearch.value;
  const searchProductValue = searchProduct.value;
  if (isConsumerSearchValue) {
    return {
      "ltk-id": searchProductValue?.ltkId ?? "",
      "product-id": searchProductValue?.id ?? "",
      "advertiser-name": productDetails.value?.advertiserName ?? "",
      url: searchProductValue?.hyperlink ?? "",
      index: props?.position ?? "",
    };
  }
  return {
    "ltk-id": product?.postId ?? "",
    "product-id": product?.productReferenceId ?? "",
    "advertiser-name": product?.retailerDisplayName ?? "",
    url: product?.linkUrl ?? "",
    index: props.position ?? "",
  };
});

const impressionPayload = computed(() => {
  const isConsumerSearchValue = isConsumerSearch.value;
  const searchProductValue = searchProduct.value;
  if (isConsumerSearchValue) {
    return createProductImpression(Actions.View, {
      product_id: props.productId,
      promotion_id: searchProductValue?.ltkId ?? "",
      position: props.position,
      creator_id: props.profileId ?? "",
    });
  }
  return createProductImpression(Actions.View, {
    product_id: props.productId,
    promotion_id: product?.postId ?? "",
    position: props.position,
    creator_id: props.profileId ?? "",
  });
});

return { __sfc: true,props, i18n, store, creatorProductStore, experimentsStore, productsStore, productDetailsStore, isCreatorShopSearchEnabled, product, searchProduct, isConsumerSearch, productDetails, productImage, productName, productUrl, productPrice, amplitudePayload, impressionPayload }
}

})